import { useAccountInit, useAppConfigInit, useAuthInit } from 'hooks';
import { memo } from 'react';
import { Outlet, RouteObject, useRoutes } from 'react-router-dom';
import { publicRouteList } from 'routes';
import { AsyncNotFoundPage, VerticalLayout } from '../components';
import { PrivateRoute } from './private-route.component';

/**
 * AppRouter
 *
 * - Defines all routes (public and private).
 * - Public routes are accessible without authentication.
 * - Protected routes are wrapped inside PrivateRoute and managed by PrivateRouteList.
 */
export const AppRouter = memo(() => {
  useAuthInit();
  useAccountInit();

  const { protectedRouteList } = useAppConfigInit();

  const publicRoutes: RouteObject[] = publicRouteList.map(x => ({
    path: x.path,
    element: x.element,
    index: x.index ?? false,
  }));

  const privateRoutes: RouteObject[] = protectedRouteList.map(x => ({
    path: x.path,
    element: <PrivateRoute>{x.element}</PrivateRoute>,
    index: x.index ?? false,
  }));

  return useRoutes([
    ...publicRoutes,
    {
      element: (
        <PrivateRoute>
          <VerticalLayout>
            <Outlet />
          </VerticalLayout>
        </PrivateRoute>
      ),
      children: privateRoutes,
    },
    { path: '*', element: <AsyncNotFoundPage /> },
  ]);
});
